module.exports = __webpack_public_path__ + "media/images/top_menu_icon/tablet_resources-deecc2bb750be0157fc91f101502def0.png";